import React from "react";

import "../../scss/organisms/_section.scss";

class Section extends React.Component {
  render() {
    return (
      <section
        className={
          "section" +
          (this.props.className ? " " + this.props.className : "") +
          (this.props.active !== undefined
            ? this.props.active
              ? " active"
              : " inactive"
            : "")
        }
      >
        <div className={this.props.isFluid ? "container-fluid" : "container"}>
          {this.props.children}
        </div>
      </section>
    );
  }
}

export default Section;
